export default __webpack_public_path__ + "static/media/mechanics.550f279a.webp";